<template>
  <div class="manual-container">
    <div class="flex-row flex-spbt">
      <p class="component-title">{{ $t('TheNavbar.createReport') }}</p>
      <p class="warning-title" v-if="isIncorrect">개선된 피드백이 포함되지 않은 엑셀 파일입니다.</p>
    </div>
    <div>
      <FileUploader
        :isUploaded="isUploaded"
        @toggleUpload="toggleUpload"
        @notImprovedFeedback="notImprovedFeedback"
        :hidden="isUploaded && toggleUpload"
      />
      <p v-if="!isUploaded" class="text-danger">
        {{ $t('SAAI.CreateGradingPaper.UploadingGradingPaper.uploadMessage') }}
      </p>
    </div>
    <div v-if="isUploaded">
      <FileSetting />
      <div class="button-wrapper">
        <button @click="() => moveNextStep()">
          {{ $t('SAAI.CreateGradingPaper.UploadingGradingPaper.nextButton') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import FileUploader from './FileUploader.vue';
import FileSetting from './FileSetting.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'UploadFeedbackPaper',
  components: {
    FileUploader,
    FileSetting,
  },
  data() {
    return {
      isUploaded: false,
      isIncorrect: false,
    };
  },
  methods: {
    ...mapActions('saaiReport', ['AC_SET_NOW_QUESTION_NUMBER', 'AC_SET_REPORT_OUTPUT']),
    ...mapActions('modal', ['AC_MODAL_OPEN']),
    toggleUpload(type) {
      this.isUploaded = type;
    },
    notImprovedFeedback(type) {
      this.isIncorrect = type;
    },
    moveNextStep() {
      if (this.title) {
        this.setReportOutput();
        this.$router.push('setReport');
      } else {
        const content =
          this.$i18n.locale === 'eng'
            ? `You haven't finished setting up your grading sheet.`
            : '보고서 설정이 완료되지 않았습니다.';
        const url = '';
        this.AC_MODAL_OPEN({
          content: content,
          url: url,
        });
      }
    },
    setReportOutput() {
      const reportOutput = [];

      for (const student of this.studentObject) {
        const studentNumber = String(student.번호).padStart(5, '0');

        student.response = [];
        student.studentID = Number(student.반 + studentNumber);
        reportOutput.push(student);
      }
      this.AC_SET_REPORT_OUTPUT(reportOutput);
    },
  },
  computed: {
    ...mapState('saaiReport', {
      title: (state) => state.title,
      nowQuestionNumber: (state) => state.nowQuestionNumber,
      numberOfQuestions: (state) => state.numberOfQuestions,
      studentObject: (state) => state.studentObject,
    }),
  },
};
</script>

<style lang="scss" scoped>
.extracting-message {
  color: $MAIN_COLOR !important;
  font-weight: bold;
}
.warning-title{
  color: red;
  font-weight: bold;
  font-size: 1.2rem;
  margin-bottom: 1rem;
}
</style>
